// extracted by mini-css-extract-plugin
module.exports = {"main-component":"selectedTaskButtonHollow_main-component__23z7Z"};